import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import { extApi } from '../api/extensibilityClient';

export function TrendViewPage() {
  const { variableId = 'CORE_GDP_GROWTH' } = useParams();
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    if (variableId) extApi.trends(variableId).then(setData).catch(console.error);
  }, [variableId]);

  if (!data) return <div className="loading">Loading trend view…</div>;

  const dates = data.observations.map((o: any) => o.observation_date);
  const values = data.observations.map((o: any) => o.value);

  return (
    <div>
      <h1 className="page-title">Trend — {data.variable_name}</h1>
      <p className="page-subtitle">Historical actuals, scenario overlays, and gap to target.</p>

      <div className="card">
        <Plot
          data={[
            { type: 'scatter', mode: 'lines+markers', name: 'Actual', x: dates, y: values },
            data.target != null ? { type: 'scatter', mode: 'lines', name: 'Target', x: dates, y: dates.map(() => data.target), line: { dash: 'dot' } } : null,
          ].filter(Boolean) as any}
          layout={{ title: data.variable_name, yaxis: { title: data.unit || 'Value' }, paper_bgcolor: '#fff', plot_bgcolor: '#fff' }}
          config={{ displayModeBar: false, responsive: true }}
          style={{ width: '100%', height: 360 }}
        />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', fontSize: '0.85rem' }}>
          <div>CAGR: {data.cagr != null ? `${(data.cagr * 100).toFixed(2)}%` : '—'}</div>
          <div>Gap to target: {data.gap_to_target != null ? data.gap_to_target.toFixed(2) : '—'}</div>
          <div>Required improvement: {data.required_annual_improvement != null ? data.required_annual_improvement.toFixed(2) : '—'}</div>
          <div>Observations: {data.observations.length}</div>
        </div>
      </div>
    </div>
  );
}
